import { useEffect } from 'react';

export const useChat = isVisible => {
  // TODO remove tidio once chatwoot is used
  useEffect(() => {
    const chat = document?.getElementById('tidio-chat');
    if (chat) {
      isVisible
        ? (chat.style.display = 'unset')
        : (chat.style.display = 'none');
    }
    return () => {
      if (chat) {
        chat.style.display = 'unset';
      }
    };
  }, [isVisible]);

  useEffect(() => {
    const chat = document?.getElementById('cw-bubble-holder');
    if (chat) {
      isVisible
        ? (chat.style.display = 'unset')
        : (chat.style.display = 'none');
    }
    return () => {
      if (chat) {
        chat.style.display = 'unset';
      }
    };
  }, [isVisible]);
};
